import { h } from 'preact';
import { useState, useRef } from 'preact/hooks';
import clsx from 'clsx';
import PlayIcon from './icons/play.svg';
import PauseIcon from './icons/pause.svg';
import MuteIcon from './icons/mute.svg';
import UnmuteIcon from './icons/unmute.svg';

const VideoSrcPlayer = ({ sources, videoContainerClasses, videoClasses }) => {
  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);
  const video = useRef();

  const handlePlay = (e) => {
    if (!video?.current) return;
    if (isPlaying) {
      e.preventDefault();
      video.current.pause();
      setIsPlaying(false);
    } else {
      e.preventDefault();
      video.current.play();
      setIsPlaying(true);
    }
  };

  const handleSound = (e) => {
    if (!video?.current) return;
    if (isMuted) {
      e.preventDefault();
      video.current.muted = false;
      setIsMuted(false);
    } else {
      e.preventDefault();
      video.current.muted = true;
      setIsMuted(true);
    }
  };

  return (
    <div className={clsx('relative', videoContainerClasses)}>
      <button
        type="button"
        data-video-play
        onClick={(e) => handlePlay(e)}
        className="block group"
        ariaLabel={clsx(isPlaying ? 'Pause video' : 'Play video')}
      >
        <PlayIcon
          className={clsx(
            'absolute w-10 h-10 z-1 cursor-pointer bottom-5 right-5 lg:bottom-10 lg:right-10 group-focus:ring-2 group-focus:ring-blue-500',
            {
              hidden: isPlaying,
            },
          )}
        />
        <PauseIcon
          className={clsx(
            'absolute w-10 h-10 z-1 cursor-pointer bottom-5 right-5 lg:bottom-10 lg:right-10 group-focus:ring-2 group-focus:ring-blue-500',
            {
              hidden: !isPlaying,
            },
          )}
        />
      </button>
      <button
        type="button"
        data-video-mute
        onClick={(e) => handleSound(e)}
        className="block group"
        ariaLabel={clsx(isMuted ? 'Mute video' : 'Unmute video')}
      >
        <MuteIcon
          className={clsx(
            'absolute w-10 h-10 z-1 cursor-pointer bottom-5 right-5 lg:bottom-10 lg:right-10 -translate-x-[50px] group-focus:ring-2 group-focus:ring-blue-500',
            {
              hidden: !isMuted,
            },
          )}
        />
        <UnmuteIcon
          className={clsx(
            'absolute w-10 h-10 z-1 cursor-pointer bottom-5 right-5 lg:bottom-10 lg:right-10 -translate-x-[50px] group-focus:ring-2 group-focus:ring-blue-500',
            {
              hidden: isMuted,
            },
          )}
        />
      </button>
      <video
        muted
        autoplay
        ref={video}
        loop
        playsInline
        class={clsx(videoClasses)}
      >
        {sources.map((source, index) => (
          <source key={index} src={source.url} type={source.mimeType} />
        ))}
      </video>
    </div>
  );
};

export default VideoSrcPlayer;
